import type {ListVariation} from '~/types'

/**
 * LEVANTA, its LEVANTA_V2 sandbox and the CC (Creator Connections) lists share every Levanta page rule
 * (no sponsored, no related lists, hard 404 without a ranking, noindex). CC products carry no
 * levantaLink, so their buttons stay plain Amazon links.
 */
export function isLevantaVariation(variation: ListVariation | undefined): boolean {
  return variation === 'LEVANTA' || variation === 'LEVANTA_V2' || variation === 'CC'
}
